module.exports = __webpack_public_path__ + "static/media/btn-satellite@2x.4e98eaf3.png";